module.exports = __webpack_public_path__ + "static/media/apple-store-badge.877bc801.png";